import { useContext } from 'react';

import { TaskActionRunnerContext } from '../TaskActionRunner.constants';

const useTaskActionRunner = () => useContext(TaskActionRunnerContext);

export default useTaskActionRunner;
